import axios from 'axios'
import store from './store'
import router from './router'

let apios = axios.create()

apios.interceptors.request.use(function (config) {
  if (!store.state.token) return config
  
  config.headers.common.Authorization = 'Bearer ' + store.state.token.access_token

  return config;
});

apios.interceptors.response.use(undefined, function (err) {
  if (err.response.status === 401) {
    store.commit('logout')
    router.push('/login')  
  }
  
  throw err
});

async function login(username, password) {
  let params = {
    grant_type: 'password',
    client_id: 14,
    client_secret: 'TTqyFbmeDp7h30kyEcku2zwWIn7YtjtxS364yIXO',
    username,
    password
  };

  let response = await axios.post('/oauth/token', params)
  
  return response.data
}

export default {
  login,
  apios
}